export const SET_GIFT_DETAILS_MUTATION = "setGiftDetailsMutation";